import httpCommon from "../../../http-common";
import getErrorMessage from "../../../util";

export const edit_schedule_api = async ({ _id, ...update_fields }) => {
  const body = {
    _id,
    update_fields,
  };
  const response = await httpCommon.patch(`/v1/qc/edit_qc_schedule/`, body);
  const result = (await response).data;
  const { status, error } = result;
  if (status === "success") {
    return {
      status: true,
      message: "Schedule Updated Successfully",
    };
  }
  return {
    status: false,
    message: getErrorMessage(error),
  };
};
